import type { OnboardingProgress } from "@/app/onboarding/api/get-onboarding-progress";

export type SidebarStepStatus = "active" | "complete" | "future";

export type OnboardingStep = NonNullable<OnboardingProgress["step"]>;

export function deriveSidebarStepStatus({
  currentStep,
}: {
  currentStep: OnboardingStep;
}): {
  step1Status: "complete" | "active";
  step2Status: SidebarStepStatus;
  step3Status: SidebarStepStatus;
} {
  const step1Status = currentStep === "jtbd" ? "active" : "complete";

  let step2Status: SidebarStepStatus = "future";
  if (currentStep === "done") {
    step2Status = "complete";
  } else if (currentStep === "connect") {
    step2Status = "active";
  }

  const step3Status: SidebarStepStatus =
    currentStep === "done" ? "active" : "future";

  return { step1Status, step2Status, step3Status };
}
